export enum ProjectStatus {
    Local = 'LOCAL',
    Deleted = 'DELETED',
    Opened = 'OPENED',
    ViewingVersion = 'VIEWING_VERSION',
    Editing = 'EDITING',
    Closed = 'CLOSED',
}
